@if (type == "product-tile") {
  @for (item of instances; track item; let i = $index) {
    <div [ngStyle]="{ height: height || '380px' }" [class]="'shimmer product-tile' + (extraContainerClass ? ' ' + extraContainerClass : '')"></div>
  }
}

@if (type == "line") {
  @for (item of instances; track item; let i = $index) {
    <div
      [class]="'shimmer' + (extraContainerClass ? ' ' + extraContainerClass : '')"
      [ngStyle]="{ height: height || '10px', 'border-radius': borderRadius || '5px', width: width || randomWidths[i] || '80%' }"
    ></div>
  }
}

@if (type == "learn-video") {
  @for (item of instances; track item; let i = $index) {
    <div [class]="extraContainerClass ? extraContainerClass : ''">
      <div class="card video-grid-item hover dontgrow video" style="border-radius: 20px; overflow: hidden">
        <div class="video-grid-item-container">
          <div class="card-header image-container image-border shimmer" style="border-radius: 0px"></div>
          <div class="card-body">
            <div class="video-title-container shimmer" style="height: 20px; border-radius: 5px"></div>
            <div class="video-title-container shimmer" style="height: 20px; width: 80%; margin-top: 20px; border-radius: 5px"></div>
            <div class="video-title-container shimmer" style="height: 20px; width: 40%; margin-top: 20px; border-radius: 5px"></div>
          </div>
        </div>
      </div>
    </div>
  }
}

@if (type == "workspace-list-item") {
  @for (item of instances; track item; let i = $index) {
    <div [class]="'d-flex p-10' + (extraContainerClass ? ' ' + extraContainerClass : '')">
      <div style="width: 40px; height: 40px; border-radius: 5px" class="shimmer"></div>
      <div style="flex: 1; margin-left: 10px">
        <div style="height: 10px; width: 60%; margin-top: 5px; border-radius: 5px" class="shimmer"></div>
        <div style="height: 10px; width: 80%; margin-top: 5px; border-radius: 5px" class="shimmer"></div>
      </div>
    </div>
  }
}

@if (type == "list-item" || type == "list-item-large") {
  @for (item of instances; track item; let i = $index) {
    <ng-container *ngTemplateOutlet="listItem"></ng-container>
  }
}

@if (type == "carousel") {
  <div
    [class]="'shimmer' + (extraContainerClass ? ' ' + extraContainerClass : '')"
    [ngStyle]="{ width: width || '100%', height: height || '215px', 'border-radius': borderRadius || '30px', 'max-width': maxWidth || 'auto' }"
  ></div>
}

@if (type == "workspace") {
  <div>
    <div style="width: 200px; margin: 10px; height: 30px; border-radius: 5px" class="shimmer"></div>
    <div class="d-flex">
      <div style="width: 40%">
        <div style="margin: 10px; height: 300px; border-radius: 10px" class="shimmer"></div>
        <div class="m-10"><ng-container *ngTemplateOutlet="listItem"></ng-container></div>
        <div class="m-10"><ng-container *ngTemplateOutlet="listItem"></ng-container></div>
        <div class="m-10"><ng-container *ngTemplateOutlet="listItem"></ng-container></div>
        <div class="m-10"><ng-container *ngTemplateOutlet="listItem"></ng-container></div>
      </div>
      <div style="width: 60%; height: 900px">
        <div style="margin: 10px; height: 100%; border-radius: 10px" class="shimmer"></div>
      </div>
    </div>
  </div>
}

@if (type == "product-detail") {
  <div>
    <div class="d-flex">
      <div style="width: 180px; margin-right: 20px">
        <div style="height: 200px; width: 200px; border-radius: 10px" class="shimmer"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 90%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 70%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 60%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 50%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 60%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 70%"></div>
        <div [class]="'shimmer'" style="margin: 20px 0px; height: 30px; border-radius: 30px; width: 50%"></div>
      </div>
      <div style="width: calc(100% - 200px); margin-left: 20px; height: 400px">
        <div [class]="'shimmer'" style="margin-bottom: 10px; height: 10px; border-radius: 5px; width: 90%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 80%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 90%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 60%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px 30px 0px; height: 10px; border-radius: 5px; width: 70%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 90%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 80%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px; height: 10px; border-radius: 5px; width: 90%"></div>
        <div [class]="'shimmer'" style="margin: 10px 0px 30px 0px; height: 10px; border-radius: 5px; width: 60%"></div>
        <div class="d-flex">
          <div [ngStyle]="{ height: '280px', width: '33%', marginRight: '10px', 'border-radius': '10px' }" [class]="'shimmer product-tile'"></div>
          <div [ngStyle]="{ height: '280px', width: '33%', marginRight: '10px', 'border-radius': '10px' }" [class]="'shimmer product-tile'"></div>
          <div [ngStyle]="{ height: '280px', width: '33%', 'border-radius': '10px' }" [class]="'shimmer product-tile'"></div>
        </div>
        <div [class]="'shimmer'" style="margin: 30px 0px; height: 30px; border-radius: 30px; width: 100px"></div>
      </div>
    </div>
  </div>
}

<!-- Communities picker card. Reuses `.community-card` and mirrors the real hero's ratio,
     cap and body spacing so the grid doesn't reflow when the data lands. -->
@if (type == "community-card") {
  @for (item of instances; track item; let i = $index) {
    <div [class]="extraContainerClass ? extraContainerClass : ''">
      <div class="community-card">
        <div class="shimmer" style="width: 100%; aspect-ratio: 16 / 9.4; max-height: 350px"></div>
        <div class="community-card-body">
          <div class="shimmer" style="height: 12px; width: 94%; border-radius: 5px"></div>
          <div class="shimmer" style="height: 12px; width: 62%; margin-top: 8px; border-radius: 5px"></div>
          <div class="community-card-avatars" style="margin-top: 14px">
            @for (avatar of [0, 1, 2, 3, 4]; track avatar) {
              <div class="community-card-avatar shimmer"></div>
            }
          </div>
          <div class="community-card-latest" style="margin-top: 14px; border-color: transparent">
            <div class="community-card-latest-avatar shimmer"></div>
            <div style="flex: 1">
              <div class="shimmer" style="height: 10px; width: 38%; border-radius: 5px"></div>
              <div class="shimmer" style="height: 12px; width: 82%; margin-top: 8px; border-radius: 5px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

<!-- One activity-rail row: avatar, meta line, snippet. Matches `.communities-feed-item`. -->
@if (type == "community-feed-row") {
  @for (item of instances; track item; let i = $index) {
    <div class="communities-feed-item" style="cursor: default">
      <div class="communities-feed-avatar shimmer"></div>
      <div style="flex: 1">
        <div class="shimmer" style="height: 10px; width: 54%; border-radius: 5px"></div>
        <div class="shimmer" style="height: 12px; width: 88%; margin-top: 8px; border-radius: 5px"></div>
      </div>
    </div>
  }
}

<!-- One community feed row in list view. Mirrors `myp-community-post-list-item`'s
     subject-first card — subject, avatar + author byline, two body lines, reply count — on the
     same card colour and padding, so the real rows land in place rather than reflowing. -->
@if (type == "community-post-row") {
  @for (item of instances; track item; let i = $index) {
    <div [class]="'community-post-skeleton' + (extraContainerClass ? ' ' + extraContainerClass : '')">
      <div class="shimmer" style="height: 18px; border-radius: 5px" [style.width]="rowWidths[i % 3].subject"></div>
      <div class="d-flex align-items-center" style="margin-top: 10px">
        <div class="shimmer" style="width: 22px; height: 22px; border-radius: 11px"></div>
        <div class="shimmer" style="height: 10px; width: 96px; margin-left: 8px; border-radius: 5px"></div>
        <div class="shimmer" style="height: 8px; width: 40px; margin-left: 8px; border-radius: 4px"></div>
      </div>
      <div class="shimmer" style="height: 12px; margin-top: 12px; border-radius: 5px" [style.width]="rowWidths[i % 3].body"></div>
      <div class="shimmer" style="height: 12px; margin-top: 8px; border-radius: 5px" [style.width]="rowWidths[i % 3].bodyEnd"></div>
      <div class="shimmer" style="height: 12px; width: 34px; margin-top: 14px; border-radius: 5px"></div>
    </div>
  }
}

<ng-template #listItem>
  <div [class]="'d-flex align-items-center' + (extraContainerClass ? ' ' + extraContainerClass : '')">
    <div [ngStyle]="{ width: type == 'list-item-large' ? '200px' : '40px', height: type == 'list-item-large' ? '120px' : '40px', 'border-radius': '5px' }" class="shimmer"></div>
    <div style="flex: 1; margin-left: 10px">
      @if (type == "list-item-large") {
        <div style="height: 20px; width: 20%; margin-top: 5px; border-radius: 5px" class="shimmer"></div>
      }
      <div style="height: 15px; width: 70%; margin-top: 5px; border-radius: 5px" class="shimmer"></div>
      <div class="d-flex">
        <div style="height: 10px; width: 10%; margin-top: 5px; margin-right: 5px; border-radius: 5px" class="shimmer"></div>
        <div style="height: 10px; width: 10%; margin-top: 5px; margin-right: 5px; border-radius: 5px" class="shimmer"></div>
        <div style="height: 10px; width: 10%; margin-top: 5px; margin-right: 5px; border-radius: 5px" class="shimmer"></div>
        <div style="height: 10px; width: 10%; margin-top: 5px; border-radius: 5px" class="shimmer"></div>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <div style="width: 30px; height: 30px; border-radius: 15px" class="shimmer"></div>
      <div style="width: 30px; height: 30px; border-radius: 15px; margin-left: 20px" class="shimmer"></div>
      <fa-icon icon="chevron-right" style="color: #333; margin-left: 20px; margin-right: 10px"></fa-icon>
    </div>
  </div>
</ng-template>
